import {Component, HostBinding, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {MvtService} from '../../../common/services/mvt.service';

@Component({
  selector: 'informo-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit, OnDestroy {
  private subs: Subscription;
  @HostBinding('class.with-alert') level;
  constructor(private mvtService: MvtService) {}

  ngOnInit() {
    this.subs = this.mvtService.getAlertLevel.subscribe(level => {
      this.level = level;
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/cities/informo/faq/faq.component.ts